import React, { useId, useState } from 'react';
import { MonsterStatBreakdown, SkillBreakdown } from '../api';
import StatBreakdown from './StatBreakdown';

export function MonsterBreakdown({ title, breakdown }: { title: string; breakdown?: MonsterStatBreakdown | SkillBreakdown }) {
  const [expanded, setExpanded] = useState(false);
  const id = useId();
  const populated = !!breakdown?.modifiers?.length;
  return <div className="monster-breakdown-heading"><span className="monster-title-with-info">{title}
    {populated && <button type="button" className="monster-breakdown-open" aria-label={`${title} breakdown`}
      aria-expanded={expanded} aria-controls={id} onClick={() => setExpanded(value => !value)}>i</button>}</span>
    {populated && expanded && <div id={id} className="monster-breakdown-content"><StatBreakdown breakdown={breakdown} /></div>}
  </div>;
}
